"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDashboardEquipmentType = void 0;
var IDashboardEquipmentType;
(function (IDashboardEquipmentType) {
    IDashboardEquipmentType["Cycle"] = "cycle";
    IDashboardEquipmentType["Run"] = "run";
    IDashboardEquipmentType["Rower"] = "rower";
    IDashboardEquipmentType["Strength"] = "strength";
})(IDashboardEquipmentType || (exports.IDashboardEquipmentType = IDashboardEquipmentType = {}));
//# sourceMappingURL=dashboard-equipment-type.js.map